<template>
    <v-container class="ma-0 pa-0 steps_container" fill-height>
        <v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="start" class="ma-0 pa-0">
                <v-nav-guide
                    title="2"
                />
			</v-col>
		</v-row>

        <v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="start" class="ma-0 pa-0">
                <v-img :src="require('@/assets/images/renew/img-illust-food.svg')" />
			</v-col>
		</v-row>

        <v-row dense class="my-0 px-0 mx-7 pt-7 pb-5 div_divider">
			<v-col cols="12" align-self="start" class="ma-0 pa-0">
                <p style="font-size:14px; font-weight:bolder; color:#7a46c7; letter-spacing:-0.6px;">식이 가이드</p>
                <p style="font-size:24px; font-weight:bolder; color:#193263; letter-spacing:-1px;">{{getTitle}}</p>
			</v-col>
            <v-col cols="12" align-self="start" class="ma-0 pa-0">
                <p style="font-size:14px; line-height:24px; font-weight:bolder; color:#7584a1; letter-spacing:-0.6px;">{{getDescription}}</p>
            </v-col>
		</v-row>

        <v-row dense class="ma-0 pb-5 px-7 pt-7">
            <template v-if="isMetabolicSymdrom">
                <v-diet-card v-for="index in 6" :index="index" status="low" :key="index"/>
            </template>
            <template v-else>
                <v-diet-card v-for="index in 5" :index="index" status="high" :key="index"/>
            </template>
        </v-row>

        <v-row dense class="ma-0 pa-7 footer">
			<v-col cols="12" align-self="start" class="ma-0 pa-0">
                <p class="footer-bolder" v-html="$t('disease.footer-origin')"/>
                <p class="footer-origin"> {{ $t('dietGuide.desc') }} </p>
			</v-col>
		</v-row>

    </v-container>
</template>
<script>
    import { mapGetters } from 'vuex'
    import types from '../../store/types'
    import VNavGuide from "@/components/navGuide"
    import VDietCard from "@/components/dietCard"

    export default {
        components: {
            VNavGuide,
            VDietCard
        },
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters({
                surveyExercise : types.addItem.getters.section4,
            }),
            ...mapGetters('survey', [
                'checkupResult'
            ]),
            getTitle() {
                if(this.isMetabolicSymdrom)
                    return this.$t('dietGuide.low.title')
                return this.$t('dietGuide.high.title')
            },
            getDescription() {
                if(this.isMetabolicSymdrom)
                    return this.$t('dietGuide.low.desc')
                return this.$t('dietGuide.high.desc')
            },
            isMetabolicSymdrom() {
                // BMI >=25 또는 혈압이 130/85 이상
                return true
            },
            getDate() {
                return this.checkupResult.displayCheckupDate
            },
        },
        methods: {
        },
        mounted() {
            window.scrollTo(0, 0)
        }
    }
</script>
<style scoped>
    .main-container {
        font-family:  "NanumSquare", sans-serif;;
        padding: 0px 30px;
    }
    .guide-title {
        margin: 40px 0;
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;
        font-size: 18px;
        color: black;
        opacity: 0.5;
    }
    .desc {
        font-family: "NanumSquare", sans-serif;
        font-weight: 700;

        font-size: 16px;
        color: black;
        opacity: 0.5;
        line-height: 160%;
        margin-bottom: 40px;
    }
    .footer {
        background-color: #f3f5f7;
        font-family: "NanumSquare", sans-serif;
        font-size: 12px;
        color: #193263;
        line-height: 20px;
        letter-spacing: -0.51px;
        font-weight: bolder;
        word-break: keep-all;
    }
    .footer-bolder{
        font-weight: bolder;
    }

    .footer-origin {
        font-size: 12px;
        color: #193263;
        line-height: 20px;
        letter-spacing: -0.51px;
        
        word-break: keep-all;
    }

    .div_divider {
        border-bottom: 1px solid #e2e6ea;
    }

</style>
